import React, { useState } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import Select from "react-select";

function AddSupportTicket() {
  const [ticket, setTicket] = useState({
    subject: "",
    category: "",
    priority: "medium",
    order_id: "",
    description: "",
  });

  const [attachment, setAttachment] = useState(null);

  const categories = [
    { value: "technical", label: "Technical Issue" },
    { value: "billing", label: "Billing & Payments" },
    { value: "account", label: "Account Management" },
    { value: "order", label: "Order Related" },
  ];

  const priorityOptions = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
    { value: "urgent", label: "Urgent" },
  ];

  const vendorId = localStorage.getItem("vendorId");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTicket({ ...ticket, [name]: value });
  };

  const handleSelectChange = (field, selectedOption) => {
    setTicket({ ...ticket, [field]: selectedOption ? selectedOption.value : "" });
  };

  const handleFileChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare FormData for file upload support
    const formData = new FormData();
    formData.append("vendor_id", vendorId);
    formData.append("subject", ticket.subject);
    formData.append("category", ticket.category);
    formData.append("priority", ticket.priority);
    formData.append("order_id", ticket.order_id);
    formData.append("description", ticket.description);
    
    if (attachment) {
      formData.append("attachment", attachment);
    }

    // ✅ Log sent data to console
    console.log("--- Sending Ticket Data ---");
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      const response = await axios.post(`${baseurl}createSupportTicket`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Response from backend:", response.data);

      Swal.fire({
        icon: "success",
        title: "Ticket Submitted",
        text: "Your support request has been sent successfully.",
        timer: 2000,
        showConfirmButton: false,
        toast: true,
        position: "top-end"
      });

      setTimeout(() => {
        window.location.href = `/support/tickets`;
      }, 2100);
    } catch (error) {
      console.error("Submission Error:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Could not create ticket. Please try again.",
      });
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="page-breadcrumb d-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Support</div>
            <div className="ps-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">New Ticket</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="card border-top border-4 border-primary">
            <div className="card-body p-4">
              <h5 className="mb-4">Raise Support Ticket</h5>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  {/* Subject */}
                  <div className="col-12">
                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      placeholder="Briefly describe the issue"
                      value={ticket.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Category */}
                  <div className="col-md-6">
                    <label className="form-label">Category</label>
                    <Select
                      options={categories}
                      onChange={(opt) => handleSelectChange("category", opt)}
                      placeholder="Select Category"
                      required
                    />
                  </div>

                  {/* Priority */}
                  <div className="col-md-6">
                    <label className="form-label">Priority Level</label>
                    <Select
                      options={priorityOptions}
                      defaultValue={priorityOptions[1]}
                      onChange={(opt) => handleSelectChange("priority", opt)}
                    />
                  </div>

                  {/* Order ID */}
                  <div className="col-md-6">
                    <label className="form-label">Order ID (Optional)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="order_id"
                      placeholder="#12345"
                      value={ticket.order_id}
                      onChange={handleChange}
                    />
                  </div>

                  {/* File Upload */}
                  <div className="col-md-6">
                    <label className="form-label">Attachment (Screenshot/Log)</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                      accept="image/*,.pdf,.doc,.docx"
                    />
                  </div>

                  {/* Description */}
                  <div className="col-12">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-select"
                      name="description"
                      rows="5"
                      placeholder="Please provide details about your concern..."
                      value={ticket.description}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 text-end">
                    <button type="button" className="btn btn-light me-2" onClick={() => window.history.back()}>
                      Back
                    </button>
                    <button type="submit" className="btn btn-primary px-4">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AddSupportTicket;